import checkImageSize from "./checkImageSize";
import resizeImage from "./resizeImage";

const handleImage = async (img, save) => {
  const size = await checkImageSize(img,'user');
const { width } =  size;
  if (width <= 1440) {
    save({ data: img, size });
  } else {
   const resizedImage = await resizeImage(img);
   save({ data: resizedImage, size });
  }
};

export default handleImage;